export default "__VITE_ASSET__O4OJPUb8__"